import React from 'react';
import PropTypes from 'prop-types';
import InformationOutlineIcon from 'mdi-react/InformationOutlineIcon';

/**
 * Grey callout with a leading icon, used to surface a short explanatory
 * note within a form (e.g. what a visibility toggle does).
 */
const InfoBox = ({ icon, children, className }) => (
  <div className={`info-box${className ? ` ${className}` : ''}`}>
    <span className="info-box__icon">{icon}</span>
    <div className="info-box__content">{children}</div>
  </div>
);

InfoBox.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

InfoBox.defaultProps = {
  icon: <InformationOutlineIcon size={18} />,
  className: '',
};

export default InfoBox;
